<template>
  <div class="new-record">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Add New Virtual Card Account</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-text-field v-model="cardHolder" :rules="nameRules" label="Card Holder (*)" required></v-text-field>

                <v-text-field v-model="cardNumber" :rules="nameRules" label="Card Number (*)" required></v-text-field>

                <v-text-field v-model="cvv" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    label="CVV Code (*)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

                <v-dialog ref="dialog" v-model="modal" :return-value.sync="expireDate" width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="expireDate" label="Expire Date (*)" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker color="blue-grey" v-model="expireDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(expireDate)">OK</v-btn>
                    </v-date-picker>
                </v-dialog>

                <v-text-field v-model="appCode" :rules="nameRules" label="App Code (*)" required></v-text-field>

                <v-text-field v-model="phone" :rules="nameRules" label="Phone Number (*)" required></v-text-field>

                <v-textarea v-model="remark" outlined label="Remark (Optional)"></v-textarea>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('dialogHide')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="$store.state.snackSuccess" :disabled="!valid" @click="saveRecord">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>

export default {
  props: [ 'dialog', 'Type', 'counter' ],

  data: () => ({
    
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      date: new Date().toISOString().substr(0, 10),
      modal: false,

      cardHolder: '',
      cardNumber: '',
      cvv: '',
      expireDate: '',
      appCode: '',
      phone: '',
      remark: '',

  }),

  methods: {

    saveRecord() {

      this.$store.dispatch('storeVcard', {
        card_holder: this.cardHolder,
        card_number: this.cardNumber,
        cvv: this.cvv,
        expire_date: this.expireDate,
        app_code: this.appCode,
        phone: this.phone,
        remark: this.remark,
        counter: parseInt(this.counter) 
      })
      .then(() => { this.$emit('dialogHide') });

    }

  },

}
</script>

<style>

</style>